(function () {
    'use strict';

    var ngBarcode = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/components/barcode/ng-barcode.html',
        controllerAs: 'vm',
        bindings: {
            text:'<',
            width: '<',
            height: '<',
            unit:'<',
            dpi:'<',
            hideText:'<'
        },

        controller: ['$scope', '$timeout', '$element','UidService', function ($scope, $timeout, $element, UidService) {
            var vm = this;

            function initOptions() {
                vm.option = {
                    width:4,
                    fontOptions: "bold",
                    font: "Microsoft YaHei, 微软雅黑, 黑体, SimHei",
                    displayValue: !vm.hideText
                };
                // 设置默认值
                vm.unit = vm.unit || 'px';

                if (vm.dpi && vm.unit == 'mm') {
                    vm.option.height = mmToPx(vm.height,vm.dpi);
                    vm.option.fontSize = mmToPx(vm.height/2,vm.dpi);
                }
            }

            function mmToPx(mm,dpi) {
                if (mm && dpi) {
                    return (mm / 25.4) * dpi;
                }else{
                    return null
                }
            }

            function generateBarcode() {
                var barcodeElement = angular.element($element).find('#barcodeId');
                if (vm.text) {
                    barcodeElement.JsBarcode(vm.text, vm.option);
                }
            }

            vm.$onInit = function() {
                initOptions();
                generateBarcode();
            };

            vm.$onChanges = function(changes) {
                if (changes.text || changes.width || changes.height || changes.unit || changes.dpi || changes.hideText) {
                    initOptions();
                    generateBarcode();
                }
            };
        }]
    };
    angular.module('gwApp')
        .component('ngBarcode', ngBarcode);

})();
